import { LoadProfile, RateCalculator, type RateInterface } from '@bellawatt/electric-rate-engine';
import { RateKey, UserPrefs } from '../../types';
import selectRate from '../rate/selectRate';

const CARE_DISCOUNT = 0.2;

const calcElectricBill = (rate: RateKey, loadProfile: LoadProfile, userPrefs: UserPrefs) => {
  const annualCost = new RateCalculator({
    ...(selectRate(rate, userPrefs.zipcode) as RateInterface),
    loadProfile,
  }).annualCost();

  const careAdjustment = userPrefs.hasCareDiscount ? 1 - CARE_DISCOUNT : 1;
  return annualCost * careAdjustment;
};

export default calcElectricBill;
